import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import { IconFont } from '../../../component/icon-font';
import MagicIcon from '../../../component/svgs/new/magic.svg';
import MagicDisableIcon from '../../../component/svgs/new/magic-disable.svg';

interface VideoBackgroundButtonProps {
  isBlur: boolean;
  onBlurBackground: () => void;
}

const VideoBackgroundButton = (props: VideoBackgroundButtonProps) => {
  const { isBlur, onBlurBackground } = props;

  return (
    <Tooltip title={isBlur ? 'Disable virtual background' : 'Enable virtual background'}>
      <button
        onClick={onBlurBackground}
        style={{ ...styles.circleBtn, ...(isBlur ? styles.redBtn : styles.whiteBtn) }}
        className="press-effect-btn"
        title={'Virtual background'}
      >
        <img
          src={isBlur ? MagicDisableIcon : MagicIcon}
          alt="magic"
          style={{
            width: 24,
            height: 24
          }}
        />
      </button>
    </Tooltip>
  );
};

export { VideoBackgroundButton };

const styles = {
  circleBtn: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    border: 'none'
  },
  whiteBtn: {
    background: '#f0f0f0',
    color: '#1a1a1a'
  },
  redBtn: {
    background: '#C0392B',
    color: '#fff',
    boxShadow: '0 2px 8px rgba(192,57,43,0.4)'
  }
};
